import { Button, DialogClose, InterceptDialog } from "@hellocarbo/lasagne";
import { use } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { PortalContainerContext } from "@/contexts";
import useOutboundQueryParams from "@/hooks/useOutboundQueryParams";
import useSegmentEvent from "@/hooks/useSegmentEvent";

const UpsellPlanModal = ({
  children,
  show = false,
}: {
  children: React.ReactNode;
  show?: boolean;
}) => {
  const { t } = useTranslation(["importDeposit"]);
  const { sendSegmentEvent } = useSegmentEvent();
  const freeTrialQueryParams = useOutboundQueryParams("freetrial");

  const { container } = use(PortalContainerContext);

  return (
    <InterceptDialog
      show={show}
      title={t("importDeposit:upsellPlanModal.title")}
      description={t("importDeposit:upsellPlanModal.description")}
      warningMessage={t("importDeposit:upsellPlanModal.warning")}
      portalContainer={container as Element}
      footer={
        <>
          <DialogClose asChild>
            <Button
              shape="outline"
              onClick={() => sendSegmentEvent("Discover the plans")}
              as={Link}
              to="/pricing"
            >
              {t("importDeposit:upsellPlanModal.secondaryCta")}
            </Button>
          </DialogClose>
          <DialogClose asChild>
            <Button
              as="a"
              href={`https://www.hellocarbo.com/reservez-votre-demo${freeTrialQueryParams}`}
              onClick={() => sendSegmentEvent("Subscription Asked")}
              shouldOpenNewTab
            >
              {t("importDeposit:upsellPlanModal.cta")}
            </Button>
          </DialogClose>
        </>
      }
    >
      {children}
    </InterceptDialog>
  );
};

export default UpsellPlanModal;
